export type CsvDelimiter = ',' | ';'

export const detectDelimiter = (headerLine: string): CsvDelimiter => {
  const header = headerLine ?? ''
  const semicolons = (header.match(/;/g) || []).length
  const commas = (header.match(/,/g) || []).length
  return semicolons > commas ? ';' : ','
}

export const splitCsvLine = (line: string, delimiter: CsvDelimiter): string[] => {
  const input = line ?? ''
  const values: string[] = []
  let current = ''
  let inQuotes = false

  for (let index = 0; index < input.length; index++) {
    const ch = input[index]

    if (ch === '"') {
      if (inQuotes && input[index + 1] === '"') {
        current += '"'
        index++
      } else {
        inQuotes = !inQuotes
      }
      continue
    }

    if (!inQuotes && ch === delimiter) {
      values.push(current)
      current = ''
      continue
    }

    current += ch
  }

  values.push(current)
  return values
}

const padToLength = (values: string[], expectedColumns: number): string[] => {
  if (expectedColumns <= 0) return values
  if (values.length >= expectedColumns) return values
  return values.concat(Array.from({ length: expectedColumns - values.length }, () => ''))
}

export const splitCsvLineWithFallback = (
  line: string,
  primaryDelimiter: CsvDelimiter,
  fallbackDelimiter: CsvDelimiter,
  expectedColumns: number
): string[] => {
  const rawPrimary = splitCsvLine(line, primaryDelimiter)
  if (expectedColumns <= 0) return rawPrimary

  const rawFallback = splitCsvLine(line, fallbackDelimiter)

  // If primary looks wrong and fallback looks right, use fallback.
  if (rawPrimary.length !== expectedColumns && rawFallback.length === expectedColumns) {
    return padToLength(rawFallback, expectedColumns)
  }

  // Special-case: mixed delimiter files sometimes produce 1 "giant" column.
  if (rawPrimary.length === 1 && expectedColumns > 1 && rawFallback.length === expectedColumns) {
    return padToLength(rawFallback, expectedColumns)
  }

  return padToLength(rawPrimary, expectedColumns)
}
